module.exports = __webpack_public_path__ + "img/ico-bank.51d41a0f.svg";